export enum LeadListDialogType {
  CONTACT_CHECK = 'contact_check',
  NEW_OPPORTUNITIES = 'new_opportunities',
  COLD_LEADS = 'cold_leads',
}
